<template>
  <div
    v-if="decodedAuthentication !== null"
    class="modal fade"
    id="vertex-product"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    data-bs-backdrop="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title fw-semibold" id="exampleModalLabel">
            Browse to other Vertex products
          </h5>

          <button
            type="button"
            class="btn-close shadow-none"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <div class="row">
            <h5
              v-if="accesibleApps !== null && accesibleApps.length == 0"
              class="text-center fw-semibold"
            >
              No other product available.
            </h5>

            <template v-else>
              <div
                v-for="(app, index) in accesibleApps"
                :key="index"
                class="col-md-6 mb-3"
              >
                <a
                  class="card flex justify-content-center align-items-center"
                  style="
                    cursor: pointer;
                    text-decoration: none;
                    outline-style: none;
                  "
                  :href="app.url"
                  target="_blank"
                >
                  <template
                    v-if="
                      app.appLowerCase == 'core' ||
                      app.appLowerCase == 'pentesting' ||
                      app.appLowerCase == 'password manager' ||
                      app.appLowerCase == 'xsurflog'
                    "
                  >
                    <img
                      :src="app.logo"
                      class="card-img-top"
                      :title="app.appFullName"
                    />
                  </template>

                  <template v-else>
                    <img
                      :src="app.logo"
                      class="card-img-top"
                      :title="app.appFullName"
                      style="width: 74%"
                    />

                    <span class="fw-semibold mb-2" style="font-size: 14px">{{
                      app.appFullName
                    }}</span>
                  </template>
                </a>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { storeToRefs } from "pinia";
import axios from "axios";

import { useAuthenticationStore } from "@/stores/authentication";
import { useOrganisationsStore } from "@/stores/organisations";

const authenticationStore = useAuthenticationStore();
const { authentication, decodedAuthentication } =
  storeToRefs(authenticationStore);

const organisationsStore = useOrganisationsStore();
const { selectedOrganisation } = storeToRefs(organisationsStore);

const accesibleApps = ref(null);

const initializeSwitchApplicationLogo = async () => {
  accesibleApps.value = [];

  if (
    typeof selectedOrganisation.value !== "undefined" &&
    selectedOrganisation.value !== null
  ) {
    await axios
      .get(`organisations/${selectedOrganisation.value.id}/products`)
      .then((response) => {
        if (response.data.success) {
          accesibleApps.value = [];

          var apps = [];

          for (const product of response.data.products) {
            var appFullName = product.application.trim();
            var appLowerCase = appFullName.toLowerCase();

            if (
              appLowerCase == "soc" ||
              !product.organisation_product_id ||
              apps.includes(appLowerCase)
            ) {
              continue;
            }

            var logo = null;

            if (appLowerCase == "core") {
              logo = require("@/assets/img/applications/core.png");
            } else if (appLowerCase == "pentesting") {
              logo = require("@/assets/img/applications/pentesting.png");
            } else if (appLowerCase == "password manager") {
              logo = require("@/assets/img/applications/password_manager.png");
            } else if (appLowerCase == "xsurflog") {
              logo = require("@/assets/img/applications/xsurflog.png");
            } else {
              logo = require("@/assets/img/applications/vertex-new.png");
            }

            let href = product.login_url.trim();

            let lastChar = href.charAt(href.length - 1);

            if (appLowerCase == "core") {
              if (lastChar !== "/") {
                href += "/";
              }
            } else {
              while (lastChar === "/") {
                href = href.trim().slice(0, -1).trim();

                lastChar = href.charAt(href.length - 1);
              }
            }

            accesibleApps.value.push({
              appFullName,
              appLowerCase,
              logo,
              url: `${href}?access_token=${authentication.value}&org_selected=${selectedOrganisation.value.id}`,
            });

            apps.push(appLowerCase);
          }
        }
      })
      .catch(() => {});
  }
};

watch(
  selectedOrganisation,
  () => {
    initializeSwitchApplicationLogo();
  },
  { immediate: true },
);
</script>
